import { isEmpty, isEqual } from 'lodash';
import React, { useState } from 'react';

import { fetchDeviceMakeModels } from '@/resources/devices.resources';
import { MakeModels } from '../MakeModels/MakeModels';

import type { DevicePlatformInterface } from 'sonata-static-storage/lib/schemas/campaign/targeting/devicePlatform.schema';
import type { DeviceMakeModelType } from 'sonata-static-storage/lib/schemas/targeting/DeviceMakeModel/DeviceMakeModels.types';

type Props = Omit<React.ComponentProps<typeof MakeModels>, 'getDeviceMakeModels'> & {
  className?: string;
  deviceTypes: DevicePlatformInterface[];
};

function MakeModelsMultiflightWrapper(props: Props) {
  const { className, deviceTypes, id, makeModels, onMakeModelsChanged } = props;
  const [selectedMakeModels, setSelectedMakeModels] = useState<DeviceMakeModelType[]>(makeModels);

  const token = {};

  const requestDeviceTypes = deviceTypes.filter(dt => dt.enable).map(dt => dt.name);

  if (isEmpty(requestDeviceTypes)) {
    return null;
  }

  const handleOnMakeModelsChanged = (newMakeModels: DeviceMakeModelType[]) => {
    if (isEqual(newMakeModels, selectedMakeModels)) {
      return;
    }
    setSelectedMakeModels(newMakeModels);
    onMakeModelsChanged(newMakeModels);
  };

  return (
    <div className={className}>
      <MakeModels
        {...props}
        getDeviceMakeModels={() => fetchDeviceMakeModels(requestDeviceTypes, token)}
        id={`${id}-MakeModelsMultiflightWrapper`}
        omitQuestion
        onMakeModelsChanged={handleOnMakeModelsChanged}
      />
    </div>
  );
}

MakeModelsMultiflightWrapper.displayName = 'MakeModelsMultiflightWrapper';
export default MakeModelsMultiflightWrapper;
